module.exports = __webpack_public_path__ + "static/media/故障情况.de23aa52.png";


//////////////////
// WEBPACK FOOTER
// ./src/AntD/assets/img/diagnostic/故障情况.png
// module id = 5067
// module chunks = 0